// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"62":"favorites","138":"profile","348":"comparison","389":"404","594":"about","884":"admin"}[chunkId] || chunkId) + "." + {"62":"2ab30b5e","138":"43378cbb","348":"fc7af463","389":"2e11823a","496":"15dcaa31","594":"92b7a4a2","884":"70ed6750"}[chunkId] + ".css";
};